/**
 * Lyric Boost Design System - Spacing Tokens
 * 
 * Consistent spacing scale for margins, padding, and gaps.
 * Based on an 8px base unit for a harmonious layout system.
 */

export const spacing = {
  // Base unit (8px)
  base: 8,

  // Spacing scale (in pixels and corresponding rem values)
  xxs: 4,    // 0.25rem
  xs: 8,     // 0.5rem
  sm: 12,    // 0.75rem
  md: 16,    // 1rem
  lg: 24,    // 1.5rem
  xl: 32,    // 2rem
  xxl: 48,   // 3rem
  xxxl: 64,  // 4rem

  // Component-specific spacing
  component: {
    buttonPadding: {
      small: '6px 12px',
      medium: '8px 16px',
      large: '12px 24px',
    },
    inputPadding: '12px 16px',
    cardPadding: {
      small: 12,    // 0.75rem
      medium: 16,   // 1rem
      large: 24,    // 1.5rem
    },
    sectionPadding: {
      mobile: 16,   // 1rem
      tablet: 24,   // 1.5rem
      desktop: 32,  // 2rem
    },
  },

  // Layout spacing
  layout: {
    containerPadding: {
      mobile: 16,   // 1rem
      tablet: 24,   // 1.5rem
      desktop: 32,  // 2rem
    },
    sectionMargin: {
      small: 32,    // 2rem
      medium: 48,   // 3rem
      large: 64,    // 4rem
    },
  },
} as const;

// Type export
export type Spacing = typeof spacing;
